export function checkIfTimeIsKnown(datetime: string) {
  return !datetime.endsWith('T00:00:01.000Z');
}
